<template>
  <v-dialog-old ref="dialog" id="account" @shown="onShownEvent" @hidden="resetComponentData()" :onCloseEsc="onclose">
    <dialog-metro
        ref="metroDialog"
        :checked-options="M.clinic.metros"
        :metro-options="metroOptions"
        :city="M.clinic.city"
        @confirm="onConfirmMetros"/>

    <dialog-metro
        ref="searchMetroDialog"
        :default-options="M.clinic.searchMetros"
        :checked-options="M.clinic.searchMetrosManual"
        :metro-options="metroOptions"
        :city="M.clinic.city"
        @confirm="onConfirmSearchMetros"/>

    <dialog-clinic-subscription
        ref="clinicSubscriptionDialog"
        @confirm="handleCreatedSubscription"
        @edit="handleChangedSubscription"
    ></dialog-clinic-subscription>

    <dialog-clinic-types
        ref="clinicTypesDialog"
        v-model="M.clinic.types"
        :proprietary="M.clinic.proprietary"
        :type-options="typeOptions"/>

    <image-cropper
        ref="cropper"
        :img="M.clinic.img"
        type="clinics"
        @crop-upload-success="cropUploadSuccess"
        upload-url="/imageCropperNew/clinics"
    />

    <a href="#close" style="text-align: center" @click.stop.prevent="onclose"></a>
    <ValidationObserver ref="clinicEditForm">
      <form>
        <fieldset :disabled="!canEdit">
          <legend>Учетная запись</legend>
          <div class="alert alert-warning" v-if="M.clinic.moderationNeeded" style="margin-bottom: 10px;">
            Внимание! Изменения отправлены на проверку. После проверки менеджером обновлённая информация
            появится на сайте.
          </div>
          <table class="grid">
            <tr>
              <td width="700" valign="top" style="padding-top: 5px;">
                <table class="grid">
                  <tr>
                    <td valign="top" width="150">
                      <drag-and-drop @fileDropped="openCropWithNewFile">
                        <div class="imageCropper">
                          <button type="button" v-show="M.clinic.img !== ''"
                                  class="resetBtn small redHover" tooltip="Удалить логотип"
                                  @click.prevent.stop="imageCropperDelete">
                            <i class="fas fa-trash"></i>
                          </button>
                          <img src=""
                               :src="M.clinic.img ? storagePublicUrl + '/images/clinics/150x150/' + M.clinic.img : ''"
                               width="150" height="150" @click.prevent.stop="imageCropperOpen"
                               style="cursor: pointer; background-image: url(/_assets/pic_clinic.svg);"/>

                          <i class="button small" @click.prevent.stop="openClinicPage"
                             width="150"
                             v-tooltip="`${$parent.$parent.frontendUrl}/${M.clinic.city}/clinic/${M.clinic.url}`"
                             :disabled="!M.clinic.id" style="margin: 5px 0 !important;">
                            <i class="fas fa-link"></i>
                            Показать на сайте
                          </i>
                        </div>
                      </drag-and-drop>
                    </td>
                    <td valign="top">
                      <vee-textarea
                          v-model="M.clinic.name"
                          taClass="large"
                          placeholder="Название"
                          :v-beautify="'capitalize itemclean typograf'" rules="required"
                          taStyle="min-height: 128px"
                          autofocus
                      ></vee-textarea>
                      <table class="grid">
                        <tr>
                          <td width="33%" v-if="M.clinic.id !== ''" style="width: 100%">
                            <label>Внутренний</label>
                            <input :value="M.clinic.ratingInternal"
                                   readonly
                                   v-tooltip="{ content: infoTooltip }"/>
                          </td>
                          <td width="33%" style="min-width: 190px; width: 100%">
                            <label>Форма собственности</label>
                            <ValidationProvider vid="proprietary" name="Форма собственности" rules="required"
                                                v-slot="{ errors }">
                              <v-select
                                  :class="{ 'hasError': errors[0]}"
                                  v-tooltip.right="{
                                                                content: errors[0],
                                                                template: $errTemplate,
                                                            }"
                                  v-model="M.clinic.proprietary"
                                  :options="[
                                                            { value: 'private', text: 'Частная' },
                                                            { value: 'municipal', text: 'Государственная' }
                                                        ]"
                              ></v-select>
                            </ValidationProvider>
                          </td>
                          <td width="33%"
                              v-tooltip="{content: networkTooltip}"
                              :style="'max-width: ' + (M.clinic.id ? 172 : 262) + 'px; min-width: ' + (M.clinic.id ? 172 : 262) + 'px'">
                            <label>Сеть</label>
                            <v-select
                                v-model="M.clinic.displayed_network"
                                :disabled="networkSelectionDisabled"
                                :options='[
                                                            {
                                                                value: "",
                                                                text: "не сетевая"
                                                            },
                                                            ...networksOptions
                                                        ]'
                            ></v-select>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table class="grid">
                  <tr>
                    <td width="25%">
                      <label>Город</label>
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <v-select
                            @close="recalcCityHandler"
                            v-model="M.clinic.city"
                            :class="{ 'hasError': errors[0]}"
                            v-tooltip.right="{
                                                                content: errors[0],
                                                                template: $errTemplate,
                                                            }"
                            :disabled="M.clinic.id !== '' && !$can('admin.clinics.changeCity')"
                            :options='
                                                    cityOptions.map(({ text, value }) => {
                                                        return {
                                                            text,
                                                            value
                                                        }
                                                    })
                                                '
                        ></v-select>
                      </ValidationProvider>
                    </td>

                    <td v-if="localityOptions.find(findByCity)" width="25%">
                      <label>Населенный пункт</label>
                      <v-select
                          @close="recalcLocalityHandler"
                          v-model="M.clinic.locality"
                          :options='[
                                                {
                                                    value: "",
                                                    text: "\u00a0"
                                                },
                                                ...localityOptions.filter(findByCity).map(({ text, value }) => {
                                                    return {
                                                        text,
                                                        value
                                                    };
                                                })
                                            ]'
                      ></v-select>
                    </td>
                    <td width="25%" v-if="districtOptions.filter(findByCity)">
                      <label>Район</label>
                      <v-select
                          v-model="M.clinic.district"
                          :options='filteredDistrictOptions'
                      ></v-select>
                    </td>
                    <td width="25%" v-if="areaOptions.find(findByCity)">
                      <label>Округ</label>
                      <v-select
                          v-model="M.clinic.area"
                          :options='
                                                areaOptions.filter(findByCity).map(({ text, value }) => {
                                                    return {
                                                        text,
                                                        value
                                                    };
                                                })
                                            '
                      ></v-select>
                    </td>
                  </tr>
                </table>

                <table class="grid">
                  <tr>
                    <td>
                      <vee-input
                          @blur="recalcAddressHandler"
                          v-model="M.clinic.address"
                          rules="required"
                          placeholder="Адрес"
                      />
                    </td>
                    <td width="140">
                      <vee-button :disabled="M.clinic.city === ''" errText="Требуется указать клинику на карте!"
                                  @click="showAddressOnMap" :rules="{required: !M.clinic.markLat}"
                                  class="small">
                        <i class="fad fa-map-location-dot"
                           v-tooltip="`${(+M.clinic.markLat).toFixed(6)}, ${(+M.clinic.markLong).toFixed(6)}`"></i>
                        Показать на карте
                      </vee-button>
                    </td>
                  </tr>
                </table>

                <div v-if="metroOptions.find(findByCity)">
                  <label>Метро для анкеты</label>
                  <div class="textarea" @click.prevent.stop="editMetros">
                                    <span class="comma">
                                        <span v-for="(metro, index) in M.clinic.metros" :key="index">
                                            {{ metroOptions.find(item => item.value === metro).text }}</span>
                                    </span>
                    <button type="button" class="tiny">Выбрать метро</button>
                  </div>
                  <template>
                    <label>Метро для поиска</label>
                    <div class="textarea" @click.prevent.stop="editSearchMetros">
                                        <span class="comma">
                                            <span v-for="(metro, index) in M.clinic.searchMetros" :key="index + metro">
                                                {{ metroOptions.find(item => item.value === metro).text }}</span>
                                            <span v-for="(metro, index) in M.clinic.searchMetrosManual"
                                                  :key="index + metro">
                                                {{ metroOptions.find(item => item.value === metro).text }}</span>
                                        </span>
                      <button v-if="M.clinic.markLat && M.clinic.markLong" type="button" class="tiny">
                        Выбрать метро
                      </button>
                    </div>
                  </template>
                </div>

                <label>Категории</label>
                <ValidationProvider rules="required|clinicTypes" v-slot="{ errors }">
                  <div class="textarea" :disabled="M.clinic.proprietary === ''" :class="{ 'hasError': errors[0]}"
                       v-model="M.clinic.types"
                       v-tooltip="{
                                content: errors[0],
                                template: $errTemplate,
                                }"
                       @click.prevent.stop="editTypes">
                                <span class="comma">
                                    <span v-for="type in M.clinic.types">{{
                                        typeOptions.find(item => item.value === type).text
                                      }}</span>
                                </span>
                    <button v-if="M.clinic.proprietary !== ''" type="button" class="tiny">Выбрать</button>
                  </div>
                </ValidationProvider>

              </td>
              <td valign="top" style="width:480px;padding: 5px;min-width: 480px !important">
                <div id="Ymap" style="width: 100%; height: 350px; background-color: #D0CFCF;"></div>
              </td>
            </tr>
          </table>

          <hr style="margin: 5px 0 5px 0"/>

          <table class="grid">
            <tr>
              <td valign="top" width="700">
                <label>Страница ДОКТУ</label>
                <div style="width:700px" v-if="M.clinic.id === ''">
                  <table class="grid">
                    <tr>
                      <td width="50" valign="top">
                        <a :href="$parent.$parent.frontendUrl+'/'+(M.clinic.city === '' ? '—' : M.clinic.city)+'/clinic/'+M.clinic.url"
                           class="text-ellipsis"
                           target="_blank">{{
                            $parent.$parent.frontendUrl
                          }}/{{ M.clinic.city === '' ? '—' : M.clinic.city }}/clinic/</a>
                      </td>
                      <td>
                        <vee-input
                            v-model="M.clinic.url"
                            @input="checkUrl"
                            :rules="{required: true, urlAvailable: !urlAvailable}"
                            :invalid="!urlAvailable"
                            :class="{incorrectUrl: !urlAvailable, 'hidden-url': true}"/>
                      </td>
                      <td width="50">
                        <button class="small" @click.prevent.stop="transliterate">trans</button>
                      </td>
                      <td width="60">
                        <div class="label bg-red" v-if="M.clinic.url === ''"
                             style="top: -3px; position: relative;">пустой
                        </div>
                        <div class="label bg-red" v-if="M.clinic.url !== '' && !urlAvailable"
                             style="top: -3px; position: relative;">занят
                        </div>
                        <div class="label bg-green" v-if="M.clinic.url !== '' && urlAvailable"
                             style="top: -3px; position: relative;">ОК
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div style="width:700px" v-else class="input text-ellipsis">
                  <a :href="$parent.$parent.frontendUrl+'/'+(M.clinic.city === '' ? '—' : M.clinic.city)+'/clinic/'+M.clinic.url"
                     target="_blank"
                     class="text-ellipsis"
                  >
                    {{ $parent.$parent.frontendUrl.replace("https://", "") }}/{{
                      M.clinic.city === '' ? '—' : M.clinic.city
                    }}/clinic/{{ M.clinic.url }}
                  </a>
                </div>
                <div style="width:495px; display: inline-block">
                  <label>Официальное название</label>
                  <input v-model="M.clinic.nameOfficial"
                         v-beautify.literal="'capitalize itemclean striptags typograf'">
                </div>
                <div style="width:200px;display: inline-block">
                  <label>Год основания</label>
                  <input min="1800" :max="new Date().getFullYear()" v-model="M.clinic.estYear" type="number" units="г">
                </div>
                <div style="width:320px; display: inline-block">
                  <label>ФИО главного врача</label>
                  <input v-model="M.clinic.chiefDoctor">
                </div>
                <div style="width:170px;display: inline-block">
                  <label>Прием по страховке</label>
                  <v-select
                      v-model="M.clinic.insuranceType"
                      :options=insuranceTypes
                  ></v-select>
                </div>
                <div style="width:200px;display: inline-block">
                  <label>Номер лицензии</label>
                  <input v-model="M.clinic.licenceNum"
                         v-beautify.literal="'itemclean striptags typograf'">
                </div>
              </td>
              <td width="250" style="display: flex; flex-direction: column;margin-top: -5px;">
                <label style="margin-left: 25px;">Режим работы</label>

                <div>
                  <span style="width: 20px; display: inline-block;">пн</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.monFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.monTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.monFrom)"
                      :options="timeOptionsMon"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">вт</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.tueFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.tueTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.tueFrom)"
                      :options="timeOptionsTue"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">ср</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.wedFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.wedTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.wedFrom)"
                      :options="timeOptionsWed"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">чт</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.thuFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.thuTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.thuFrom)"
                      :options="timeOptionsThu"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">пт</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.friFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.friTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.friFrom)"
                      :options="timeOptionsFri"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">сб</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.satFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.satTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.satFrom)"
                      :options="timeOptionsSat"
                  ></v-select>
                </div>

                <div>
                  <span style="width: 20px; display: inline-block;">вс</span>

                  <v-select
                      style="width: 100px; display: inline-block;"
                      v-model="M.clinic.workTime.sunFrom"
                      :options="timeOptionsFull"
                  ></v-select>

                  <v-select
                      v-model="M.clinic.workTime.sunTill"
                      style="width: 100px; display: inline-block;"
                      :disabled="['', 'off', '24h'].includes(M.clinic.workTime.sunFrom)"
                      :options="timeOptionsSun"
                  ></v-select>
                </div>
              </td>
              <td valign="top" width="250">
                <div>
                  <label>
                    <input type="checkbox" v-model="M.clinic.hasTerminal"/>
                    <span>Есть оплата картой</span>
                  </label>
                  <label>
                    <input type="checkbox" v-model="M.clinic.hasLaboratory"/>
                    <span>Есть лаборатория</span>
                  </label>
                  <label>
                    <input type="checkbox" v-model="M.clinic.hasParking"/>
                    <span>Есть парковка</span>
                  </label>
                  <label>
                    <input type="checkbox" v-model="M.clinic.hasHospital"/>
                    <span>Есть стационар</span>
                  </label>
                </div>
              </td>
            </tr>
          </table>

          <hr style="margin: 5px 0 5px 0"/>

          <table class="grid">
            <tr>
              <td>
                <label>Телефон регистратуры</label>
                <input :disabled="disableRegistryPhone"
                       v-model-phone="M.clinic.registryPhone"
                       :class="{'hasError' : registryPhoneError}"
                       v-tooltip="{
                                       content: registryPhoneError,
                                       template: $errTemplate,
                                   }">
                <label>Email</label>
                <vee-input name="Email" v-model="M.clinic.email" rules="email"/>
              </td>
              <td>
                <label>Официальный сайт клиники</label>
                <vee-input
                    v-model="M.clinic.website"
                    vid="website"
                    :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                    :v-beautify="striptagsTrim"
                />
                <label>Telegram (id)</label>
                <vee-input v-model="M.clinic.socialTg"
                           vid="socialTg"
                           :rules="{clinicAnyOfSix: clinicAnyOfSix}"
                           :v-beautify="striptagsTrimNoHttp"
                />
              </td>
              <td>
                <label>Страница Вконтакте</label>
                <vee-input v-model="M.clinic.socialVk"
                           vid="socialVk"
                           :rules="{clinicAnyOfSix: clinicAnyOfSix, socialVk: true}"
                           :v-beautify="striptagsTrimNoHttp+' vk'"
                />
                <label>WhatsApp (номер телефона)</label>
                <ValidationProvider
                    v-slot="{ errors }"
                    :rules="{clinicAnyOfSix: clinicAnyOfSix, socialWhatsApp: true}"
                >
                  <input
                      v-model-phone="M.clinic.socialWhatsApp"
                      :class="{'hasError': errors[0] || whatsAppPhoneError}"
                      id="socialWhatsApp"
                      v-tooltip="{
                                                        content: whatsAppPhoneError,
                                                        template: $errTemplate,
                                                    }"
                  >
                </ValidationProvider>
              </td>
              <td>
                <label>Страница Одноклассники</label>
                <vee-input v-model="M.clinic.socialOk"
                           vid="socialOk"
                           :rules="{clinicAnyOfSix: clinicAnyOfSix, socialOk: true}"
                           :v-beautify="striptagsTrimNoHttp+' ok'"
                />
                <label>Канал YouTube</label>
                <vee-input
                    v-model="M.clinic.socialYoutube"
                    vid="socialYoutube"
                    :rules="{clinicAnyOfSix: clinicAnyOfSix, socialYoutube: true}"
                    :v-beautify="striptagsTrimNoHttp+' youtube'"
                />
              </td>
            </tr>

          </table>

          <hr style="margin: 5px 0 5px 0"/>

          <label>Описание</label>
          <v-quill ref="quill" v-model="M.clinic.description" :config="{eventsOnBlur: true}"/>

          <label>Фотографии клиники</label>

          <photo-gallery
              id="photos"
              v-model="M.clinic.photos"
              :imagesBasePath="storagePublicUrl + '/images/clinicPhotos/120x120/'"
              uploadUrl="clinics/uploadPhoto"
              buttonText="Добавить<br>фотографии<br>клиники"
              @file-uploaded="photosUploaded"
          ></photo-gallery>

          <hr style="margin: 5px 0 5px 0"/>

          <label>Лицензии клиники</label>

          <photo-gallery
              id="licenses"
              v-model="M.clinic.licences"
              :imagesBasePath="storagePublicUrl + '/images/clinicLicences/Wx120/'"
              uploadUrl="clinics/uploadLicence"
              buttonText="Добавить<br>лицензии"
              @file-uploaded="licenseUploaded"
          ></photo-gallery>
        </fieldset>
        <template>
          <fieldset :disabled="!canEdit" v-if="M.clinic.proprietary === 'municipal'"
                    style="overflow: initial !important;">
            <legend>Иерархия</legend>
            <table class="grid">
              <tr>
                <td width="30%">
                  <label>Родительская клиника</label>
                  <div class="textarea" style="position:relative;" v-if="M.parent">
                                    <span>
                                        <span :class="M.parent.deleted_at ? 'deleted' : ''">{{ M.parent.name }}</span>
                                        <span v-if="M.parent.deleted_at">(Клиника удалена)</span>
                                        <br>
                                        <span v-if="M.parent.address">{{ M.parent.city }}, {{ M.parent.address }}</span>

                                        <button class="tiny redHover" style="position: absolute; right: 2px; top: 2px;"
                                                @click.prevent="removeParentClinic">✖</button>
                                    </span>
                  </div>

                  <v-select
                      :options="foundParentClinics"
                      @search-change="findParentClinic"
                      @remove="addParentClinic"
                      placeholder="Выберите родительскую клинику"
                  ></v-select>
                </td>
              </tr>

              <hr style="margin: 5px 0 5px 0"/>

              <tr>
                <td>
                  <label>Дочерние клиники</label>
                  <div class="textarea" v-for="child in M.children" style="position: relative">
                                    <span>
                                        <span :class="child.deleted_at ? 'deleted' : ''">{{ child.name }}</span>
                                        <span v-if="child.deleted_at">(Клиника удалена)</span>
                                        <br>
                                        <span :class="child.deleted_at ? 'deleted' : ''"
                                              v-if="child.address">{{ child.city }}, {{ child.address }}</span>
                                        <button class="tiny redHover" style="position: absolute; right: 2px; top: 2px;"
                                                @click.prevent="removeChildClinic(child.id)">✖</button>
                                    </span>
                  </div>

                  <v-select
                      v-on:remove="addChildrenClinic"
                      :options="foundChildrenClinics"
                      @search-change="findChildClinic"
                      placeholder="Выберите дочернии клиники"
                  ></v-select>
                </td>
              </tr>
            </table>
          </fieldset>

          <fieldset :disabled="!canEdit" style="overflow: initial !important;">
            <legend>Конкуренты</legend>
            <competitors
                :competitors-list=competitors
                :competitor-urls="M.competitorUrls"
                v-on:send-url="updateCompetitorUrl"
                v-on:remove-url="removeCompetitorUrl"
            />
          </fieldset>

          <fieldset v-if="canReadTariff" :disabled="!canEdit" style="overflow: initial !important;">
            <legend>Подписки</legend>

            <table class="table" style="table-layout: fixed;">
              <thead>
              <tr>
                <th>Тариф</th>
                <th>Длительность</th>
                <th>Действует с/по</th>
                <th width="100">Цена</th>
                <th width="320">Опции</th>
                <th width="60">&nbsp</th>
              </tr>
              </thead>
              <tbody>
                  <template v-for="(row, index) in M.subscriptions">
                      <tr v-if="deletedSubscriptions.indexOf(row.id) === -1" :key="index">
                          <td>
                              <span v-if="row.tariff === 'ABONEMENT'">Подписка Стандарт</span>
                              <span v-if="row.tariff === 'ABONEMENT_PLUS'">Подписка Премиум</span>
                              <span v-if="row.tariff === 'ABONEMENT_LITE'">Подписка Лайт</span>
                              <span v-if="row.tariff === 'LEADS_ALL'">Лидген</span>
                              <span v-if="row.tariff === 'LEADS_NEW'">Лидген (первичные)</span>
                              <span v-if="row.tariff === 'ONLY_LK'">Личный кабинет</span>

                              <span v-if="row.id === ''" class="label label-danger"
                                    style="top:-2px; position: relative;">новая</span>
                          </td>
                          <td>
                              <template v-if="row.duration">{{ row.duration }}дн</template>
                              <template v-else>∞</template>
                          </td>
                          <td>
                              <span
                                  :invalid="!!M.subscriptions[index-1] && (M.subscriptions[index-1].dateTill >= row.dateFrom || isEmptyDateTill(index)) ">
                                  {{ row.dateFrom | formatDatePeriod(row.dateTill) }}
                              </span>
                          </td>
                          <td align="right">
                              <template v-if="row.price !== null">{{ row.price ? row.price : 0 }}руб</template>
                              <template v-else>&mdash;</template>
                          </td>
                          <td class="option-list">
                              <span class="option" v-if="row.option_map">Карты</span>
                              <span class="option" v-if="row.option_calltracking">Коллтрекинг</span>
                              <span class="option" v-if="row.option_callback">Обратный звонок</span>
                              <span class="option" v-if="row.option_patients_choice">Выбор пациентов</span>
                          </td>
                          <td align="center" style="padding: 0">
                              <button class="tiny blueHover" @click.prevent.stop="editSubscription(index)" v-if="canEditTariff">
                                  Ред
                              </button>
                              <button v-if="row.id === '' || canDeleteSubscription(row.dateTill)"
                                      class="tiny redHover"
                                      @click.prevent.stop="subscriptionCancel(index, row)">✖
                              </button>
                          </td>
                      </tr>
                  </template>
              <tr v-if="canEditTariff">
                <td colspan="5" style="padding: 0">
                  <button class="small"
                          style="margin: 4px 0 0 2px !important;"
                          @click.prevent.stop="createSubscription">Добавить подписку на тариф
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <div style="display: flex; justify-content: space-between; align-items: center">
              <div>
                <label>Менеджер</label>
                <v-select
                    width="500"
                    v-model="M.clinic.reportManager_id"
                    :options='[
                        {
                            value: "",
                            text: "\u00a0"
                        },
                        ...userOptions.map(row => {
                            return {
                                value: row.id,
                                text: row.fio + " - " + row.login + " (" + row.params.report.emailLogin + ")"
                            };
                        })
                    ]'
                ></v-select>
              </div>
              <div style="margin-top: 10px;">
                <button v-if="!linkedWithCrm" class="small" @click.prevent="linkWithCrm" style="width: 103px">
                  Связать CRM
                </button>
                <div v-else>
                  <span>CRM: <a :href="crmUrl" target="_blank">{{ crmUrl }}</a></span>
                </div>
                <a :href="'/admin/clinics/downloadReport/' + M.clinic.id"
                   target="_blank"
                   class="button small"
                   style="display: block; margin-top: 5px !important; width: 103px">
                  Скачать отчет
                </a>
              </div>
            </div>

            <label>Комментарий (не публикуется)</label>
            <textarea v-model="M.account.description"></textarea>
          </fieldset>
          <fieldset :disabled="!canEdit" style="overflow: initial !important;">
            <legend>Прямые номера</legend>
            <table class="grid">
              <colgroup>
                <col width="25%">
                <col width="25%">
                <col width="25%">
                <col width="25%">
              </colgroup>
              <tr>
                <td>
                  <strong>Doctu.ru (используется при импорте)</strong>
                </td>
                <td>
                  <label>Calltouch</label>
                  <input v-model-phone="M.clinic.calltouchPhone"
                         pattern="(\+?\d[- .\(\)]*){7,13}"
                         :class="{'hasError' : calltouchPhoneError}"
                         v-tooltip="{
                                           content: calltouchPhoneError,
                                           template: $errTemplate,
                                       }"
                         style="font-weight: bold;"/>
                </td>
                <td>
                  <label>Callkeeper</label>
                  <input v-model-phone="M.clinic.phone"
                         pattern="(\+?\d[- .\(\)]*){7,13}"
                         :class="{'hasError' : doctuPhoneError}"
                         v-tooltip="{
                                           content: doctuPhoneError,
                                           template: $errTemplate,
                                       }"
                         style="font-weight: bold;"/>
                </td>
                <td style="display: flex; align-items: flex-end; height: 47px;">
                  <label>
                    <input type="checkbox" v-model="M.clinic.uploadPhoneToYandexFeed" :value="true">
                    <span>Выгружать в фид Яндекса</span>
                  </label>
                  <i class="fa-solid fa-circle-info"
                     v-tooltip="{content: 'Если галочка стоит, то выгружаем подменный номер (Логика какой номер передавать - такая же, как и при публикации на сайт).<br>' +
                        'Если галочка стоит, но оба поля пустые, тогда выгружаем прямой (независимо от галочки).<br>' +
                        'Если галочки нет, выгружаем прямой номер клиники (если, вдруг, прямого нет, то ничего не выгружаем).<br>' +
                        'Номер в фид выгружаем только если у клиники активный тариф Стандарт или Премиум'}"/>
                </td>
              </tr>
            </table>
          </fieldset>
          <fieldset :disabled="!canEdit" :class="{collapsed: !M.clinic.reportOn}">
            <legend>
              <label>
                <input type="checkbox" v-model="M.clinic.reportOn" :value="true">
                <span>Автоматизированная email отчетность</span>
              </label>
            </legend>
            <table class="grid">
              <tr>
                <td width="25%">
                  <label>Кому имя</label>
                  <vee-input type="text" v-model="M.clinic.reportToName" :disabled="!M.clinic.reportOn"
                             :rules="{required: M.clinic.reportOn}"/>
                </td>
                <td width="25%">
                  <label>Кому email</label>
                  <vee-input type="text" v-model="M.clinic.reportTo" :disabled="!M.clinic.reportOn" name="«Кому email»"
                             :rules="{required: M.clinic.reportOn, email: true}"/>
                </td>
                <td width="25%">
                  <label>Копия email</label>
                  <vee-input name="«Копия email»" type="text" v-model="M.clinic.reportCc" :disabled="!M.clinic.reportOn"
                             rules="email"/>
                </td>
                <td width="25%"></td>
              </tr>
              <tr>
                <td colspan="4">
                  <vee-textarea rows="3" v-model="M.clinic.reportMessage"
                                :disabled="!M.clinic.reportOn"
                                :rules="{required: M.clinic.reportOn}"/>
                  <button class="tiny redHover" @click.prevent.stop="resetReportText"
                          :disabled="!M.clinic.reportOn">
                    Стандартный текст
                  </button>
                </td>
              </tr>
            </table>
          </fieldset>
          <fieldset v-if="$can('admin.clinics.pricelist')">
            <legend>
              <div style="display: flex">
                <span>Прайс-листы</span>
              </div>
            </legend>
            <div class="pricelist">
              <div class="statistic" style="font-size: 15px;" v-if="M.clinic.prices_statistic">
                <label>
                  <input type="checkbox" v-model="M.clinic.is_medflex_on" style="margin: 0 8px 0 2px;">
                  <span>МедФлекс</span>
                </label>

                <div>
                  <div style="margin-left: 0.5rem;display:inline-block">
                    <input v-model="M.clinic.price_type" type="radio" value="DOCTU_SERVICES" :disabled="Boolean(M.clinic.is_medflex_on)">
                  </div>
                  <b>Дерево услуг:</b> выбрано: {{ M.clinic.prices_statistic.tree.total }},
                  с ценами: {{ M.clinic.prices_statistic.tree.withPrice }}
                </div>
                <div>
                  <div style="margin-left: 0.5rem;display:inline-block">
                    <input v-model="M.clinic.price_type" type="radio" value="PRICE_LIST" :disabled="Boolean(M.clinic.is_medflex_on)">
                  </div>
                  <b>Прайс-листы:</b>
                  <template v-if="!M.clinic.prices_statistic.pricelists.last">Нет загруженных файлов прайс-листов
                  </template>
                  <template v-else>
                                    <span>
                                        <template v-if="M.clinic.prices_statistic.pricelists.published">Опубликован: {{
                                            M.clinic.prices_statistic.pricelists.published.updated_at | formatDate
                                          }}</template>
                                        <template v-else>Нет опубликованного прайс-листа</template>
                                    </span>
                  </template>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset v-if="M.users.length > 0">
            <legend>Пользователи</legend>
            <table class="table">
              <thead>
              <tr>
                <th>Логин</th>
                <th>ФИО</th>
                <th>Email</th>
                <th>&nbsp;</th>
              </tr>
              </thead>
              <tbody v-if="M.users.length >0">
              <tr v-for="(user, index) in M.users"
                  :key="index" class="hover"
                  :class="{del: user.deleted_at !== null}">
                <td>
                  <b>{{ user.login }}</b>
                </td>
                <td>{{ user.fio }}</td>
                <td>{{ user.email }}</td>
                <td v-if="user.deleted_at === null" class="user-section__cell">
                  <div class="user-section__buttons">
                    <button class="tiny blue user-section__admin-button"
                            @click.prevent.stop="tryLoginAsUser(user.login)" v-if="canActAsClinic">Войти
                    </button>
                    <button v-if="user.email && canEdit" class="tiny user-section__admin-button"
                            @click.prevent="$root.resetPassword(user.email)">Сброс пароля
                    </button>
                  </div>
                </td>
                <td v-else>Удален</td>
              </tr>
              </tbody>
            </table>
          </fieldset>
          <create-user-fieldset @fetchUser="fetchUser"/>
        </template>
      </form>
    </ValidationObserver>
    <footer>
      <v-loading-component @click="onUpdate" v-if="canEdit">
        <template slot-scope="{ loadingClass }">
          <button :disabled="!needSave" :class="[{green: needSave}, loadingClass]">Сохранить</button>
        </template>
      </v-loading-component>
      <template>
        <v-loading-component @click="loginAsSupport" v-show="M.account.id" v-if="canSupport">
          <template slot-scope="{ loadingClass }">
            <button :class="['blue', loadingClass]">Техподдержка</button>
          </template>
        </v-loading-component>
        <v-loading-component v-if="canDelete && (M.clinic.id !== '')" @click="deleteClinic" v-show="M.account.id">
          <template slot-scope="{ loadingClass }">
            <button :class="['redHover', loadingClass]">Удалить</button>
          </template>
        </v-loading-component>
      </template>
    </footer>
  </v-dialog-old>
</template>

<script>
import Vue from "vue";

import DialogMetro from "@dialogs/common/clinics/MetroDialog";
import DialogClinicTypes from "@dialogs/common/clinics/ClinicTypesDialog";
import DialogClinicSubscription from "@dialogs/admin/clinics/ClinicSubscriptionDialog";
import yMapsMixin from '@mixins/YMaps.vue';
import imageCropper from '@base/ImageCropper.vue';
import {mapState} from "vuex";
import {STORAGE_PUBLIC} from "@global/const";
import {TIME_OPTIONS} from "@global/const";
import PhotoGallery from "@common/PhotoGallery";
import CreateUserFieldset from "@common/CreateUser";
import dragAndDrop from '@base/DragAndDrop.vue';
import {initialState} from "./ClinicEditFields";
import Competitors from "@dialogs/components/clinic/Competitors";

export default {
  components: {
    Competitors,
    dragAndDrop,
    imageCropper,
    DialogMetro,
    DialogClinicTypes,
    DialogClinicSubscription,
    PhotoGallery,
    CreateUserFieldset,
  },

  mixins: [yMapsMixin],
  props: {
    userOptions: {
      type: Array,
      required: false
    },
    competitors: {
      type: Array
    },
  },
  data() {
    return initialState();
  },
  filters: {
    formatTime(time) {
      function isDateEmpty(date) {
        return (
            (typeof date === 'undefined') ||
            (date === null) ||
            (date === '') ||
            (date === '0000-00-00') ||
            (date === '0000-00-00 00:00:00')
            // !moment(date).isValid() // долго
        );
      }

      if (isDateEmpty(time)) return '';

      if (time.substr(2, 1) === ':') {
        return time.substr(0, 5);

      } else {
        return time.substr(11, 5);
      }
    },
  },
  mounted() {
    this.$store.dispatch('dictionary/fetchAllOptions');
  },
  watch: {
    'M.clinic.proprietary'(val, old) {
      if (old !== '') {
        this.M.clinic.types = [];
        this.M.clinic.displayed_network = '';
      }
      if (val === 'private') {
        this.M.children = [];
        this.M.parent = null;
      }
    },
    needSave(val) {
      if (val && !(this.actionType === 'create' || this.currentUser.role === 'admin')) {
        window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
      } else {
        window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
      }

    },
    'M.clinic.workTime.monFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.monTill = '';
      } else {
        this.timeOptionsMon = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.tueFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.tueTill = '';
      } else {
        this.timeOptionsTue = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.wedFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.wedTill = '';
      } else {
        this.timeOptionsWed = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.thuFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.thuTill = '';
      } else {
        this.timeOptionsThu = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.friFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.friTill = '';
      } else {
        this.timeOptionsFri = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.satFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.satTill = '';
      } else {
        this.timeOptionsSat = TIME_OPTIONS;
      }
    },
    'M.clinic.workTime.sunFrom'(val) {
      if (['', '24h', 'off'].includes(val)) {
        this.M.clinic.workTime.sunTill = '';
      } else {
        this.timeOptionsSun = TIME_OPTIONS;
      }
    },
    'M.clinic.city'(val) {
      if (val !== '') {
        this.axios.post('/networksByCity', {city: val}).then(response => {
          this.networks = response.data;

          if (this.M.clinic.displayed_network !== null && this.M.clinic.displayed_network !== '') {
            if (this.networks.find(item => item.id === this.M.clinic.displayed_network) === undefined) {
              alert('Город сети не соответствовал городу клиники, поэтому была снята текущая сеть');
              this.M.clinic.displayed_network = '';
            }
          }
        });
      }
    },
    'M.clinic.registryPhone'(val) {
      this.registryPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (!val.trim() || val.match(phoneRegex)) {
        return;
      }

      this.registryPhoneError = 'Некорректный номер телефона';
    },
    'M.clinic.calltouchPhone'(val) {
      this.calltouchPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (!val.trim() || val.match(phoneRegex)) {
        return;
      }

      this.calltouchPhoneError = 'Некорректный номер телефона';
    },
    'M.clinic.phone'(val) {
      this.doctuPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (!val.trim() || val.match(phoneRegex)) {
        return;
      }

      this.doctuPhoneError = 'Некорректный номер телефона';
    },
    'M.clinic.socialWhatsApp'(val) {
      this.whatsAppPhoneError = null;

      const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
      if (!val.trim() || val.match(phoneRegex)) {
        return;
      }

      this.whatsAppPhoneError = 'Некорректный номер телефона';
    },
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser,
      cityOptions: state => state.dictionary.cityOptions,
      localityOptions: state => state.dictionary.localityOptions,
      districtOptions: state => state.dictionary.districtOptions,
      metroOptions: state => state.dictionary.metroOptions,
      areaOptions: state => state.dictionary.areaOptions,
      typeOptions: state => state.dictionary.typeOptions
    }),
    canEdit() {
      return this.$canAny(['admin.clinics.update', 'network.clinics.*']) &&
          !(this.currentUser.isSupport && this.M.clinic.moderationNeeded)
    },
    adminEdit() {
      return this.$canAny(['admin.clinics.update'])
    },
    canCreate() {
      return this.$canAny(['admin.clinics.create', 'network.clinics.*'])
    },
    disableRegistryPhone() {
      return this.M.hasActiveSubscription &&
          this.M.subscription?.tariff !== 'ONLY_LK' &&
          this.$canAny(['network.clinics.*']) &&
          !this.currentUser.isSupport;
    },
    canDelete() {
      return this.$canAny(['admin.clinics.delete', 'network.clinics.*'])
    },
    canReadTariff() {
      return this.$canAny(['admin.clinics.tariff.read']);
    },
    canEditTariff() {
      return this.$canAny(['admin.clinics.tariff.update']);
    },
    canSupport() {
      return this.$canAny(['admin.clinics.support', 'admin.clinics.support_lite'])
    },

    canActAsClinic() {
      return this.$canAny(['admin.clinics.actAs', 'network.clinics.*'])
    },

    networkSelectionDisabled() {
      return this.M.clinic.city === '' ||
          this.networksOptions.length === 0 ||
          this.M.clinic.proprietary === ''
    },
    networkTooltip() {
      if (this.M.clinic.city === '') {
        return 'Не выбран город!';
      }
      if (this.networksOptions.length === 0) {
        return 'В данном городе отсутствуют сети';
      }
      return '';
    },
    hierarchyExcludeSearchIds() {
      let res = [];
      res.push(this.M.clinic.id);
      if (this.M.parent !== null) {
        res.push(this.M.parent.id);
      }
      this.M.children.forEach(child => {
        res.push(child.id)
      })
      return res;
    },
    clinicAnyOfSix() {
      return ['@website', '@socialVk', '@socialOk', '@socialYoutube', '@socialTg', this.M.clinic.socialWhatsApp, this.M.clinic.proprietary];
    },
    needSave() {
      return (this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.M).hashCode())) || this.actionType === 'create' || this.currentUser.role === 'admin';
    },

    reportManagerIdRequired() {
      const today = this.$moment().format("YYYY-MM-DD");
      const lastSubscription = this.M.subscriptions[this.M.subscriptions.length - 1];

      if (this.M.subscriptions.length === 0) {
        return false;
      } else if ((this.M.subscriptions.length > 0) &&
          ((today <= lastSubscription.dateTill) || this.isEmptyDateTill(this.M.subscriptions.length))) {
        return true;
      }
      return false;
    },

    striptagsTrimNoHttp() {
      return "striptags trim nohttp";
    },

    striptagsTrim() {
      return "striptags trim";
    },

    storagePublicUrl() {
      return STORAGE_PUBLIC;
    },

    networksOptions: function () {
      if (this.M.clinic.proprietary === '') {
        return [];
      }
      return this.networks
          .filter((item) => item.proprietary === this.M.clinic.proprietary)
          .map(row => {
            return {
              value: row.id,
              text: row.name
            };
          });
    },

    filteredDistrictOptions: function () {
      return this.districtOptions.filter(this.findByCity).map(({text, value}) => {
        return {
          text,
          value
        };
      })
    }
  },
  methods: {
    updateCompetitorUrl(data) {
      if (data.index !== null) {
        this.M.competitorUrls[data.index] = data.newVal;
      } else {
        this.M.competitorUrls.push(data.newVal);
      }
    },
    removeCompetitorUrl(index) {
      if (index !== null) {
        this.M.competitorUrls.splice(index, 1);
      }
    },
    linkWithCrm() {
      this.axios.post('clinics/crm/bp/renew-by-doctu-url', {
        doctuUrl: this.$parent.$parent.frontendUrl.replace("https://", "") + '/' + (this.M.clinic.city === '' ? '—' : this.M.clinic.city) + '/clinic/' + this.M.clinic.url,
        city: this.M.clinic.city,
        name: this.M.clinic.name,
        address: this.M.clinic.address,
        network: 'net',
        website: this.M.clinic.website,
      }).then((res) => {
        this.linkedWithCrm = true
        this.crmUrl = res.data.crmUrl
      })
    },

    fetchUser(user) {
      if (user === null) {
        Vue.delete(this.M, 'user')
      } else {
        Vue.set(this.M, 'user', user)
      }
    },
    recalcAddressHandler() {
      this.recalcMapModal('buffClinicAddress', 'address');
    },

    recalcCityHandler() {
      this.recalcMapModal('buffClinicCity', 'city');
    },

    recalcLocalityHandler() {
      this.recalcMapModal('buffClinicLocality', 'locality');
    },

    recalcMapModal(buffField, originField) {
      if (this[buffField]) {
        if (this[buffField] !== this.M.clinic[originField]) {
          return () => this.$modal('Пересчитать координаты?',
              {
                name: 'Пересчитать',
                callback: () => {
                  this[buffField] = this.M.clinic[originField];
                  this.showAddressOnMap();
                }
              },
              {
                name: 'Не пересчитывать',
                callback: () => {
                  this[buffField] = this.M.clinic[originField];
                }
              }
          )
        }
      } else {
        return () => {
          this[buffField] = this.M.clinic[originField];
        }
      }
    },

    removeParentClinic: function () {
      this.M.parent = null;
    },

    removeChildClinic: function (id) {
      this.M.children = this.M.children.filter(item => {
        return item.id !== id;
      });
    },

    addParentClinic: function (payload) {
      this.M.parent = {
        id: payload.id,
        name: payload.text,
        city: payload.city,
        address: payload.address
      };
      this.$nextTick(() => {
        this.foundParentClinics = [];
      });
    },

    addChildrenClinic: function (payload) {
      this.M.children.push({
        id: payload.id,
        name: payload.text,
        city: payload.city,
        address: payload.address
      })
      this.$nextTick(() => {
        this.foundChildrenClinics = [];
      });
    },

    valueSetterTest: function (newValue) {
      console.log(newValue)
    },

    findClinicByName: function (name, type) {
      return this.axios.post('/admin/clinics/getListForHierarchy', {
        type: type,
        filter: {
          nameOrAddress: name,
          excludeIds: this.hierarchyExcludeSearchIds
        }
      });
    },

    findParentClinic: function (query) {
      if (query.length > 1) {
        this.findClinicByName(query, 'parent').then(res => {
          this.foundParentClinics = res.data.map(item => {
            return {
              id: item.id,
              text: item.name,
              city: item.city,
              address: item.address
            }
          })
        })
      } else {
        this.foundChildrenClinics = [];
      }
    },

    findChildClinic: function (query) {
      if (query.length > 1) {
        this.findClinicByName(query, 'children').then(res => {
          this.foundChildrenClinics = res.data.map(item => {
            return {
              id: item.id,
              text: item.name,
              city: item.city,
              address: item.address
            }
          })
        })
      } else {
        this.foundChildrenClinics = [];
      }

    },
    onShownEvent(e) {
      ymaps.ready(() => {
        this.initMap();
        this.$nextTick(() => {
          if (this.M.clinic.markLat !== 0 && this.M.clinic.markLong !== 0) {
            this.updateMap(this.M.clinic.markLat, this.M.clinic.markLong, this.M.clinic.mapZoom);
          }
        })
      });
    },
    infoTooltip() {
      return `   <div class="tooltip-content">
                        <table>
            <tr>
            <td>Есть описание клиники</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasDescription + `<!--              -->&nbsp;×&nbsp;40000
            </td>
            </tr>
            <tr>
            <td>Есть отзывы о клинике</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasShowInFeedRatings + `<!--        -->&nbsp;×&nbsp;8000×Кол
            </td>
            </tr>
            <tr>
            <td>Есть отзывы о врачах</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasShowInFeedDoctorRatings + `<!--  -->&nbsp;×&nbsp;2000×Кол
            </td>
            </tr>
            <tr>
            <td>Есть аватарка</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasImg + `<!--                      -->&nbsp;×&nbsp;1000
            </td>
            </tr>
            <tr>
            <td>Есть телефон</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasPhone + `<!--                    -->&nbsp;×&nbsp;500
            </td>
            </tr>
            <tr>
            <td>Есть фотографии</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasPhotos + `<!--                   -->&nbsp;×&nbsp;250
            </td>
            </tr>
                        <tr>
            <td>Есть график работы</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasWorktime + `<!--                 -->&nbsp;×&nbsp;100
            </td>
            </tr>
            <tr>
            <td>Есть лицензии</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasLicences + `<!--                 -->&nbsp;×&nbsp;50
            </td>
            </tr>
            <tr>
            <td>Есть сайт</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasWebsite + `<!--                  -->&nbsp;×&nbsp;10
            </td>
            </tr>
            <tr>
            <td>Есть Vk</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasSocialVk + `<!--                  -->&nbsp;×&nbsp;10
            </td>
            </tr>
            <tr>
            <td>Есть Ok</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasSocialOk + `<!--                  -->&nbsp;×&nbsp;10
            </td>
            </tr>
            <tr>
            <tr>
            <td>Есть Канал YouTube</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasSocialYoutube + `<!--            -->&nbsp;×&nbsp;10
            </td>
            </tr>
            <tr>
            <td>Есть оф. название</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasNameOficial + `<!--              -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть главный врач</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasChiefDoctor + `<!--              -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть год основания</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasEstYear + `<!--                  -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть ДМС/ОМС</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasIsuranceType + `<!--             -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть оплата картой</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasTerminal + `<!--                 -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть стационар</td>
            <td>` + this.M.clinic.ratingInternalDetailed.hasHospital + `<!--                 -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть лаборатория</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasLaboratory + `<!--               -->&nbsp;×&nbsp;1
            </td>
            </tr>
            <tr>
            <td>Есть парковка</td>
            <td>
            ` + this.M.clinic.ratingInternalDetailed.hasParking + `<!--                  -->&nbsp;×&nbsp;1
            </td>
            </tr>
            </table>
            </div>`;
    },
    photosUploaded: function (uploadedImageUrls, position) {
      uploadedImageUrls.reverse().forEach((url) => {
        this.M.clinic.photos.splice(position, 0, url)
      })
    },
    licenseUploaded(uploadedImageUrls, position) {
      uploadedImageUrls.reverse().forEach((url) => {
        this.M.clinic.licences.splice(position, 0, url)
      })
    },
    isEmptyDateTill(index) {
      const dateTill = this.M.subscriptions[index - 1].dateTill;

      return dateTill !== undefined && dateTill !== null && dateTill.length === 0;
    },

    findByCity(item) {
      return item.city === this.M.clinic.city;
    },

    initPhone() {
      Vue.nextTick().then(() => {
        this.M.clinic.registryPhone = this.M.clinic.registryPhone + ' ';
      })
    },
    create() {
      this.urlAvailable = true;
      this.actionType = 'create';
      this.$refs.dialog.show().then(() => {
        this.initPhone();
      });
    },

    onclose() {
      if (this.needSave === true && !(this.actionType === 'create' || this.currentUser.role === 'admin')) {
        let confirmationMessage = 'Изменения не сохранены.';

        if (confirm(confirmationMessage)) {
          this.$refs.dialog.hide();
        }
      } else {
        this.$refs.dialog.hide();
      }
      window.location.hash = '';
    },
    read: function (id, e = null) {
      this.resetComponentData();

      let requestPromise = this.axios.get('clinics/read/' + id, {});

      requestPromise.then(response => {
        this.urlAvailable = true;
        if (response.data.clinic.displayed_network === null) {
          response.data.clinic.displayed_network = '';
        }
        Vue.set(this, 'M', response.data);

        this.actionType = 'update';
        this.buffClinicAddress = this.M.clinic.address;
        this.buffClinicCity = this.M.clinic.city;
        this.buffClinicLocality = this.M.clinic.locality;
        this.$refs.dialog.show().then(() => {
          this.initPhone();
        });
        setTimeout(() => {
          this.Mhashcode = JSON.stringify(this.M).hashCode();
        }, 300)

      })

      return requestPromise;
    },

    onUpdate(btn) {
        if(!this.needSave){
            return;
        }
      btn.startLoadingAnimation();

      this.$refs.clinicEditForm.validate().then(success => {
        if (!success || this.registryPhoneError || this.doctuPhoneError || this.calltouchPhoneError || this.whatsAppPhoneError) {
          const el = document.querySelector(".hasError:first-of-type");
          if (el) {
            el.scrollIntoView({behavior: "smooth"});
          }
          btn.stopLoadingAnimation()
          return;
        }

        if (this.$refs.quill.inProcess) {
          this.$refs.quill.quillEditor.setSelection(null)
          setTimeout(() => {
            this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
          }, 450)
        } else {
          this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
        }

      });
    },
    delBadPhones() {
      if (this.M.clinic.phone !== undefined) {
        if (this.M.clinic.phone.replace(/[^0-9]/g, "").length < 4) {
          this.M.clinic.phone = ''
        }
      }
      if (this.M.clinic.registryPhone !== undefined) {
        if (this.M.clinic.registryPhone.replace(/[^0-9]/g, "").length < 4) {
          this.M.clinic.registryPhone = ''
        }
      }
    },
    update() {
      this.delBadPhones();

      let requestPromise = this.axios.post('clinics/' + this.actionType + '/' + this.M.clinic.id, this.M);

      requestPromise.then(() => {
        this.$refs.dialog.hide();
        this.$parent.$refs.table.update();
      }).catch((error) => {
      });

      return requestPromise;
    },

    deleteClinic(deleteButton) {
      deleteButton.startLoadingAnimation();

      this.$modal('Вы уверены, что хотите удалить аккаунт клиники?\nОтмена действия невозможна.', {
        callback: () => {
          this.axios.post('clinics/delete/' + this.M.clinic.id).then(() => {
            this.$refs.dialog.hide();
            this.$parent.$refs.table.update();
            deleteButton.stopLoadingAnimation();
          });
        }
      }, {
        callback: () => {
          deleteButton.stopLoadingAnimation();
        }
      });
    },

    changeMode(row, mode) {
      row.mode = mode;
      row.phone = '';
    },

    coordsToModel(coordsFromDragend) {
      this.$nextTick(function () {
        if (coordsFromDragend) {
          this.M.clinic.markLong = coordsFromDragend[1];
          this.M.clinic.markLat = coordsFromDragend[0];
        }
        //TODO что-то странное, там где я проверял поле всегда undef, надо будет проверить и сделать норм
        if (this.yMapPlacemark) {
          let coords = this.yMapPlacemark.geometry.getCoordinates();

          if (coords && !coordsFromDragend) {
            this.M.clinic.markLong = coords[1];
            this.M.clinic.markLat = coords[0];
          }
          this.M.clinic.mapZoom = this.yMap.getZoom();
        }

      });
    },

    updateDistrictName(data) {
      let oldDistrictName = (this.districtOptions.find(option => {
        return option.value === this.M.clinic.district && option.city === this.M.clinic.city;
      }) || {}).text || '[НЕ ЗАДАН]';

      let newDistrictName = (this.districtOptions.find(option => {
        return option.value === data.district && option.city === this.M.clinic.city;
      }) || {}).text || '[НЕ ЗАДАН]';

      if (oldDistrictName !== newDistrictName) {
        if (oldDistrictName === '[НЕ ЗАДАН]') {
          this.M.clinic.district = data.district;
          this.updateLocalityName(data);
        } else {
          this.$modal("Заменить район <br><b>" + oldDistrictName + "</b> на <b>" + newDistrictName + "</b>?",
              {
                name: "Заменить",
                callback: () => {
                  this.M.clinic.district = data.district;
                  this.updateLocalityName(data);
                }
              },
              {
                name: "Нет",
                callback: () => {
                  this.updateLocalityName(data);
                }
              },
              true, '', false
          );
        }
      } else {
        this.updateLocalityName(data);
      }
    },

    updateLocalityName(data) {
      let oldLocalityName = (this.localityOptions.find(option => {
        return option.value === this.M.clinic.locality && option.city === this.M.clinic.city
      }) || {}).text || '[НЕ ЗАДАН]';

      let newLocalityName = (this.localityOptions.find(option => {
        return option.value === data.locality && option.city === this.M.clinic.city
      }) || {}).text || '[НЕ ЗАДАН]';

      if (oldLocalityName !== newLocalityName) {
        if (oldLocalityName === '[НЕ ЗАДАН]') {
          this.M.clinic.locality = data.locality;
          this.updateAreaName(data);
        } else {
          this.$modal(`Заменить населенный пункт <br><b>${oldLocalityName}</b> на <b>${newLocalityName}</b>?`,
              {
                name: "Заменить",
                callback: () => {
                  this.M.clinic.locality = data.locality;
                  this.updateAreaName(data);
                }
              },
              {
                name: "Нет",
                callback: () => {
                  this.updateAreaName(data);
                }
              },
              true, '', false
          );
        }
      } else {
        this.updateAreaName(data);
      }
    },

    updateAreaName(data) {
      let oldAreaName = (this.areaOptions.find(option => {
        return option.value === this.M.clinic.area && option.city === this.M.clinic.city
      }) || {}).text || '[НЕ ЗАДАН]';

      let newAreaName = (this.areaOptions.find(option => {
        return option.value === data.area && option.city === this.M.clinic.city
      }) || {}).text || '[НЕ ЗАДАН]';

      if (oldAreaName !== newAreaName) {
        if (oldAreaName === '[НЕ ЗАДАН]') {
          this.M.clinic.area = data.area;
          this.updateMetroNames(data);
        } else {
          this.$modal("Заменить округ <br><b>" + oldAreaName + "</b> на <b>" + newAreaName + "</b>?",
              {
                name: "Заменить",
                callback: () => {
                  this.M.clinic.area = data.area;
                  this.updateMetroNames(data);
                }
              },
              {
                name: "Нет",
                callback: () => {
                  this.updateMetroNames(data);
                }
              },
              true, '', false
          );
        }
      } else {
        this.updateMetroNames(data);
      }
    },

    updateMetroNames(data) {
      const mapMetroName = (el) => {
        return (this.metroOptions.find(option => option.value === el) || {}).text || '[НЕ ЗАДАН]';
      };

      let oldMetroNames = this.M.clinic.metros.map(mapMetroName).join(', ');
      let newMetroNames = data.metros.map(mapMetroName).join(', ');

      if (oldMetroNames !== newMetroNames) {
        if ((oldMetroNames === '[НЕ ЗАДАН]') || (oldMetroNames === '')) {
          this.M.clinic.metros = data.metros;
        } else {
          this.$modal("Заменить метро <br><b>" + oldMetroNames + "</b><br> на <br><b>" + newMetroNames + "</b>?",
              {
                name: "Заменить",
                callback: () => {
                  this.M.clinic.metros = data.metros;
                }
              },
              {
                name: "Нет"
              }
          );
        }
      }
    },

    showAddressOnMap(e) {
      this.axios.post('/getCoordsByAddress', {
        city: this.M.clinic.city,
        locality: this.M.clinic.locality,
        address: this.M.clinic.address
      }).then(response => {
        const data = response.data;

        this.M.clinic.markLat = data.geoLat;
        this.M.clinic.markLong = data.geoLong;
        this.M.clinic.mapZoom = 16;

        this.M.clinic.searchMetros = data.searchMetros;
        this.M.clinic.searchMetrosManual = [];

        this.updateMap(this.M.clinic.markLat, this.M.clinic.markLong, this.M.clinic.mapZoom);

        this.updateDistrictName(data);
      });
    },

    openClinicPage() {
      window.open('http://doctu.ru/' + this.M.clinic.city + '/clinic/' + this.M.clinic.url, '_blank');
    },

    editTypes() {
      if (this.M.clinic.proprietary !== '') {
        setTimeout(() => {
          this.$refs.clinicTypesDialog.$refs.dialog.show();
        }, 190);
      }

    },

    editMetros() {
      this.$refs.metroDialog.$refs.dialog.show();
    },

    editSearchMetros() {
      if (!this.M.clinic.markLat || !this.M.clinic.markLong) {
        return;
      }
      this.$refs.searchMetroDialog.$refs.dialog.show();
    },

    onConfirmMetros(checkedOptions) {
      this.M.clinic.metros = checkedOptions;
      this.$refs.metroDialog.$refs.dialog.hide();
    },

    onConfirmSearchMetros(checkedOptions) {
      this.axios.post('/checkMetroRadius', {
        markLat: this.M.clinic.markLat,
        markLong: this.M.clinic.markLong,
        metros: checkedOptions,
      }).then(response => {
        if (response.data.wrongMetros) {
          this.$modal('Метро для поиска должны находиться не дальше 5 км от клиники',
              {
                name: "OK",
                callback: () => {
                  this.$refs.searchMetroDialog.removeWrongMetros(response.data.wrongMetros);
                }
              },
              {},
              false)

          return;
        }

        this.M.clinic.searchMetrosManual = checkedOptions;
        this.$refs.searchMetroDialog.$refs.dialog.hide();
      });
    },

    cityChanged() {
      this.M.clinic.metros = [];
      this.M.clinic.searchMetrosManual = [];
      this.M.clinic.district = '';
      this.M.clinic.area = '';
      this.M.clinic.locality = '';
    },

    transliterate() {
      this.M.clinic.url = this.$helper.transliterate(this.M.clinic.name).trimChars('-');
      this.checkUrl();
    },
    checkUrl() {
      if (this.$helper.transliterate(this.M.clinic.url).trimChars('-') !== this.M.clinic.url) {
        this.M.clinic.url = this.$helper.transliterate(this.M.clinic.url).trimChars('-');
        return;
      }
      if (this.M.clinic.url === '') {
        return;
      }
      let data = {
        id: this.M.clinic.id,
        url: this.M.clinic.url,
        model: 'Clinic'
      };
      this.axios.post('/checkUrl', data).then(response => {
        this.urlAvailable = response.data.urlAvailable;
        // this.M.clinic.url = response.data.url;
      });
    },


    loginAsSupport(loginAsButton) {
      loginAsButton.startLoadingAnimation();
      window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

      let data = {
        accountId: this.M.account.id,
        pathname: window.location.pathname
      };

      this.axios.post('/admin/loginAsSupport', data).then((response) => {
        if (response.data.status === 'OK') {
          this.openMatchedClinicRoute()
        }
        loginAsButton.stopLoadingAnimation();
      }).catch(() => {
        loginAsButton.stopLoadingAnimation();
      });
    },
    openMatchedClinicRoute() {
      this.axios.get('/clinics/firstRoute').then(response => {
        window.open(response.data.redirect, '_blank');
      });
    },
    tryLoginAsUser: function (login) {
      if (!this.M.hasActiveSubscription && !this.M.account.downgrade_notification_date && this.M.clinic.proprietary === 'private') {
        this.$modal("Вход в ЛК под пользователем клиники запустит отсчёт бесплатного периода до закрытия ЛК. <br/>Вы уверены, что хотите войти?",
            {
              btnClass: 'green',
              name: 'Нет, не входить',
              callback: () => {
              }
            },
            {
              btnClass: 'red',
              name: 'Да, войти и запустить отсчёт',
              callback: () => {
                this.loginAsUser(login)
              }
            },
            true, '', false
        );
      } else {
        this.loginAsUser(login)
      }
    },
    loginAsUser: function (login) {

      window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

      this.axios.post('loginAsUser', {login}).then((response) => {
        if (response.data.status === 'OK') {
          this.openMatchedClinicRoute()
        }
      });
    },
    loginAsNetwork: function (loginAsButton) {
      loginAsButton.startLoadingAnimation();
      window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

      this.axios.post('/network/loginAsClinic', {'id': this.M.clinic.id}).then(response => {
        loginAsButton.stopLoadingAnimation();
        if (response.data.status === 'OK') {
          this.openMatchedClinicRoute()
        }
      }).catch(() => loginAsButton.stopLoadingAnimation());
    },
    resetReportText() {
      this.M.clinic.reportMessage =
          '((ИмяПолучателя)), добрый день!\n\n' +
          'Отправляю во вложении отчет по результатам приоритетного размещения вашей клиники за ((Месяц)). \n' +
          'Также вы можете самостоятельно посмотреть результаты нашей работы в личном кабинете клиники https://manager.doctu.ru. \n\n' +
          'Если будут какие-либо вопросы – свяжитесь со мной, пожалуйста, любым удобным для вас способом.'
    },

    /*** cropper functions ***/
    openCropWithNewFile(file) {
      this.$refs.cropper.preloadFile(file);
      this.$refs.cropper.showModal();
    },
    imageCropperDelete: function (event) {
      this.$modal("Удалить логотип?", {
            name: 'Удалить',
            callback: () => {
              this.M.clinic.img = '';
            }
          },
          {
            name: 'Нет'
          }
      );
    },
    imageCropperOpen() {
      if (this.M.clinic.img === '') {
        this.$refs.cropper.showFileChooser();
      } else {
        this.$refs.cropper.showModal();
      }
    },
    cropUploadSuccess(imageUrl, field) {
      this.M.clinic.img = imageUrl;
    },
    /************************/

    removePhoto: function (index) {
      this.M.clinic.photos.splice(index, 1);
    },

    removeLicence: function (index) {
      this.M.clinic.licences.splice(index, 1);
    },

    createSubscription: function () {
      this.$refs.clinicSubscriptionDialog.createSubscription();
    },

    handleCreatedSubscription: function (subscription) {
      if (!subscription.tariff) {
        return;
      }
      if (this.checkIfSubscriptionIntersects(subscription)) {
        this.M.subscriptions.push(subscription);
      } else {
        this.$refs.clinicSubscriptionDialog.model.isInvalid = true;
      }
    },

    checkIfSubscriptionIntersects: function (subscription = {}, index = null) {
      for (const [key, another] of Object.entries(this.M.subscriptions)) {
        if (index === parseInt(key)) {
          continue;
        }
        if (
            (subscription.dateFrom >= another.dateFrom && subscription.dateFrom <= another.dateTill) ||
            (another.dateFrom >= subscription.dateFrom && another.dateFrom <= subscription.dateTill) ||
            (!another.dateTill && another.dateFrom <= subscription.dateTill) ||
            (!subscription.dateTill && subscription.dateFrom <= another.dateTill) ||
            (!subscription.dateTill && !another.dateTill)
        ) {
          return false;
        }
      }

      return true;
    },

    editSubscription: function (index) {
      this.$refs.clinicSubscriptionDialog.edit(this.M.subscriptions[index], index);
    },

    handleChangedSubscription: function (subscription, index) {
      if (!this.checkIfSubscriptionIntersects(subscription, index)) {
        this.$refs.clinicSubscriptionDialog.model.isInvalid = true;
      } else if (subscription.tariff) {
        this.M.subscriptions.splice(index, 1, subscription);
      }
    },
    resetForm() {
      this.$refs.clinicEditForm.reset();
      this.Mhashcode = null;
      this.resetComponentData();
    },
    subscriptionCancel: function (index, subscription) {
        if (!subscription.id) {
            this.M.subscriptions.splice(index, 1);
            return;
        }

        this.$modal('Вы действительно хотите удалить действующий тариф у клиники? Отменить действие будет невозможно.', {
            name: 'Да',
            callback: () => {
                this.deletedSubscriptions.push(subscription.id);
                this.M.subscriptions[index].isDeleted = true;
            },
            btnClass: 'red',
        }, {
            name: 'Нет',
            callback: () => {},
            btnClass: 'green',
        });
    },

    resetComponentData() {
      Object.assign(this.$data, initialState());
    },
    canDeleteSubscription: function (dateTill) {
      return this.$canAny(['admin.clinics.tariff.delete']) &&
          (!dateTill || this.$moment(dateTill).startOf('day') >= this.$moment().startOf('day'));
    },
  },
}
</script>

<style lang="scss">
#account {
  max-width: 1300px !important;

  & .multiselect__content-wrapper .multiselect__content {
    max-width: 700px;
  }
}

.hidden-url {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.deleted {
  text-decoration: line-through black;
}

.user-section {
  &__buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: .3rem;
  }

  &__cell {
    width: 150px;
  }
}

.pricelist {
  &__files {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;
  }

  &__file {
    font-weight: bold;
  }
}

.option-list .option:not(:last-child):after {
  content: ',';
}
</style>
